import React from "react";
import Product from "../Components/Product/ProductMain/Product";
import { useParams } from "react-router-dom";

const ProductDetails = () => {
  const { productSlug } = useParams();
  return <Product slug={productSlug} />;
};

export default ProductDetails;
